<template>
  <div class="color-official-colors">
    <b-tabs content-class="mt-3" v-model="getCurrentSubStep">
      <b-tab title="Primary color" active>
        <p>
          <color-picker
            :colors="colors"
            :results="results"
            :reference="'primaryColor'"
            v-on:set-color-event="setPrimaryColor"
          ></color-picker>
        </p>
      </b-tab>
      <b-tab v-if="bikeId != 23 && bikeId != 20" title="Secondary color">
        <div class="mb-3">
          <div class="uppercase xs-text mt-3 xs-content">You can select the same primary and secondary and have only one color used for your components/bike.</div>
          <div class="uppercase xs-text mt-3 xs-content" v-if="bikeId == 16">The secondary color is only visible on the inside of the fork.</div>
        </div>
        <p>
          <color-picker
            :colors="colors"
            :results="results"
            :reference="'secondaryColor'"
            v-on:set-color-event="setSecondaryColor"
          ></color-picker>
        </p>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Vue from "vue";

import colorPicker from "../sub-components/color-picker.vue";

Vue.component("color-picker", colorPicker);

export default {
  name: "color-official-colors",
  data() {
    return {
    };
  },
  props: ["results", "colors", "currentTab", "bikeId"],
  computed: {
    
    getCurrentSubStep: {
      get: function() {
        return this.currentTab;
      },
      set: function(e) {
        this.$emit("current-substep", e);
      }
    }
    
  },
  methods: {
    setPrimaryColor: function (e) {
      this.$emit("set-primary-color", e);
    },
    setSecondaryColor: function (e) {
      this.$emit("set-secondary-color", e);
    },
  }
};
</script>

<style lang="scss" scoped>
.color-official-colors {
  margin-bottom: 50px;
}
</style>

